function attributeToString(t) {
  return "string" != typeof t && "undefined" === (t += "") && (t = ""), jQuery.trim(t)
}
Handlebars.registerHelper('hasKey', function (obj, key, options) {
  return obj && obj.hasOwnProperty(key) ? options.fn(this) : options.inverse(this);
});

window.slate = window.slate || {}, window.theme = window.theme || {}, slate.a11y = {
  pageLinkFocus: function (t) {
    var e = "js-focus-hidden";
    t.first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(e)
      .one("blur", function () {
        t.first()
          .removeClass(e)
          .removeAttr("tabindex")
      })
  },
  focusHash: function () {
    var t = window.location.hash;
    t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t))
  },
  bindInPageLinks: function () {
    $("a[href*=#]")
      .on("click", function (t) {
        this.pageLinkFocus($(t.currentTarget.hash))
      }.bind(this))
  },
  trapFocus: function (e) {
    var t = e.namespace ? "focusin." + e.namespace : "focusin";
    e.$elementToFocus || (e.$elementToFocus = e.$container), e.$container.attr("tabindex", "-1"), e.$elementToFocus.focus(), $(document)
      .on(t, function (t) {
        e.$container[0] === t.target || e.$container.has(t.target)
          .length || e.$container.focus()
      })
  },
  removeTrapFocus: function (t) {
    var e = t.namespace ? "focusin." + t.namespace : "focusin";
    t.$container && t.$container.length && t.$container.removeAttr("tabindex"), $(document)
      .off(e)
  }
}, slate.cart = {
  cookiesEnabled: function () {
    var t = navigator.cookieEnabled;
    return t || (document.cookie = "testcookie", t = -1 !== document.cookie.indexOf("testcookie")), t
  }
}, slate.utils = {
  findInstance: function (t, e, a) {
    for (var i = 0; i < t.length; i++)
      if (t[i][e] === a) return t[i]
  },
  removeInstance: function (t, e, a) {
    for (var i = t.length; i--;)
      if (t[i][e] === a) {
        t.splice(i, 1);
        break
      } return t
  },
  compact: function (t) {
    for (var e = -1, a = null == t ? 0 : t.length, i = 0, r = []; ++e < a;) {
      var n = t[e];
      n && (r[i++] = n)
    }
    return r
  },
  defaultTo: function (t, e) {
    return null == t || t != t ? e : t
  }
}, slate.rte = {
  wrapTable: function (t) {
    var e = void 0 === t.tableWrapperClass ? "" : t.tableWrapperClass;
    t.$tables.wrap('<div class="' + e + '"></div>')
  },
  wrapIframe: function (t) {
    var e = void 0 === t.iframeWrapperClass ? "" : t.iframeWrapperClass;
    t.$iframes.each(function () {
      $(this)
        .wrap('<div class="' + e + '"></div>'), this.src = this.src
    })
  }
}, slate.Sections = function () {
  this.constructors = {}, this.instances = [], $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:section:reorder", this._onReorder.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this))
}, slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (t, e) {
    var a = $(t),
      i = a.attr("data-section-id"),
      a = a.attr("data-section-type");
    void 0 !== (e = e || this.constructors[a]) && (e = $.extend(new e(t), {
      id: i,
      type: a,
      container: t
    }), this.instances.push(e))
  },
  _onSectionLoad: function (t) {
    t = $("[data-section-id]", t.target)[0];
    t && this._createInstance(t)
  },
  _onSectionUnload: function (t) {
    var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
    e && ("function" == typeof e.onUnload && e.onUnload(t), this.instances = slate.utils.removeInstance(this.instances, "id", t.detail.sectionId))
  },
  _onSelect: function (t) {
    var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
    e && "function" == typeof e.onSelect && e.onSelect(t)
  },
  _onDeselect: function (t) {
    var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
    e && "function" == typeof e.onDeselect && e.onDeselect(t)
  },
  _onReorder: function (t) {
    var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
    e && "function" == typeof e.onReorder && e.onReorder(t)
  },
  _onBlockSelect: function (t) {
    var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
    e && "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
  },
  _onBlockDeselect: function (t) {
    var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
    e && "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
  },
  register: function (t, a) {
    this.constructors[t] = a, $("[data-section-type=" + t + "]")
      .each(function (t, e) {
        this._createInstance(e, a)
      }.bind(this))
  }
}), slate.Currency = {
  formatMoney: function (t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    var a = "",
      i = /\{\{\s*(\w+)\s*\}\}/;

    function r(t, e, a, i) {
      if (e = slate.utils.defaultTo(e, 2), a = slate.utils.defaultTo(a, ","), i = slate.utils.defaultTo(i, "."), isNaN(t) || null == t) return 0;
      e = (t = (t / 100)
          .toFixed(e))
        .split(".");
      return e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (e[1] ? i + e[1] : "")
    }
    switch ((e = e || "${{amount}}")
      .match(i)[1]) {
      case "amount":
        a = r(t, 2);
        break;
      case "amount_no_decimals":
        a = r(t, 0);
        break;
      case "amount_with_space_separator":
        a = r(t, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        a = r(t, 0, ",", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        a = r(t, 0, " ")
    }
    return e.replace(i, a)
  }
}, slate.Image = {
  preload: function (t, e) {
    "string" == typeof t && (t = [t]);
    for (var a = 0; a < t.length; a++) {
      var i = t[a];
      this.loadImage(this.getSizedImageUrl(i, e))
    }
  },
  loadImage: function (t) {
    (new Image)
    .src = t
  },
  imageSize: function (t) {
    return (t = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/)) ? t[1] : null
  },
  getSizedImageUrl: function (t, e) {
    if (null === e) return t;
    if ("master" === e) return this.removeProtocol(t);
    var a = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    return a ? (t = t.split(a[0]), a = a[0], this.removeProtocol(t[0] + "_" + e + a)) : null
  },
  removeProtocol: function (t) {
    return t.replace(/http(s)?:/, "")
  }
}, slate.Variants = function () {
  function t(t) {
    this.$container = t.$container, this.product = t.product, this.singleOptionSelector = t.singleOptionSelector, this.originalSelectorId = t.originalSelectorId, this.enableHistoryState = t.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container)
      .on("change", this._onSelectChange.bind(this))
  }
  return t.prototype = $.extend({}, t.prototype, {
    _getCurrentOptions: function () {
      var t = $.map($(this.singleOptionSelector, this.$container), function (t) {
        var t = $(t),
          e = t.attr("type"),
          a = {};
        return ("radio" !== e && "checkbox" !== e || !!t[0].checked) && (a.value = t.val(), a.index = t.data("index"), a)
      });
      return slate.utils.compact(t)
    },
    _getVariantFromOptions: function () {
      var t = this._getCurrentOptions(),
        e = this.product.variants,
        i = !1;
      return e.forEach(function (e) {
        var a = !0;
        t.forEach(function (t) {
          a = a && t.value === e[t.index]
        }), a && (i = e)
      }), i || null
    },
    _onSelectChange: function () {
      var t = this._getVariantFromOptions();
      this.$container.trigger({
        type: "variantChange",
        variant: t
      }), t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t))
    },
    _updateImages: function (t) {
      var e = t.featured_image || {},
        a = this.currentVariant.featured_image || {};
      t.featured_image && e.src !== a.src && this.$container.trigger({
        type: "variantImageChange",
        variant: t
      })
    },
    _updatePrice: function (t) {
      t.price === this.currentVariant.price && t.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
        type: "variantPriceChange",
        variant: t
      })
    },
    _updateHistoryState: function (t) {
      history.replaceState && t && (t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id, window.history.replaceState({
        path: t
      }, "", t))
    },
    _updateMasterSelect: function (t) {
      $(this.originalSelectorId, this.$container)[0].value = t.id
    }
  }), t
}(), theme.config = {
  mediaQueries: {
    xs: "screen and (max-width: 29.99em)",
    smallDown: "screen and (max-width: 47.99em)",
    small: "screen and (min-width: 30em) and (max-width: 47.99em)",
    smallUp: "screen and (min-width: 30em)",
    mediumDown: "screen and (max-width: 64em)",
    medium: "screen and (min-width: 48em) and (max-width: 64em)",
    mediumUp: "screen and (min-width: 48em)",
    largeDown: "screen and (max-width: 79.99em)",
    large: "screen and (min-width: 64.01em) and (max-width: 79.99em)",
    largeUp: "screen and (min-width: 64.01em)",
    widescreen: "screen and (min-width: 80em)"
  },
  breakpoints: {
    small: 480,
    medium: 768,
    large: 1024,
    widescreen: 1280
  }
}, "undefined" == typeof ShopifyAPI && (ShopifyAPI = {}), ShopifyAPI.onCartUpdate = function (t) {}, ShopifyAPI.updateCartNote = function (e, a) {
  var i = $(document.body),
    t = {
      type: "POST",
      url: "/cart/update.js",
      data: "note=" + attributeToString(e),
      dataType: "json",
      beforeSend: function () {
        i.trigger("beforeUpdateCartNote.ajaxCart", e)
      },
      success: function (t) {
        "function" == typeof a ? a(t) : ShopifyAPI.onCartUpdate(t), i.trigger("afterUpdateCartNote.ajaxCart", [e, t])
      },
      error: function (t, e) {
        i.trigger("errorUpdateCartNote.ajaxCart", [t, e]), ShopifyAPI.onError(t, e)
      },
      complete: function (t, e) {
        i.trigger("completeUpdateCartNote.ajaxCart", [this, t, e])
      }
    };
  jQuery.ajax(t)
}, ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  data.message && alert(data.message + "(" + data.status + "): " + data.description)
}, ShopifyAPI.addItemFromForm = function (a, e, i) {
  var r = $(document.body),
    t = {
      type: "POST",
      url: "/cart/add.js",
      data: jQuery(a)
        .serialize(),
      dataType: "json",
      beforeSend: function (t, e) {
        r.trigger("beforeAddItem.ajaxCart", a)
      },
      success: function (t) {
        "function" == typeof e ? e(t, a) : ShopifyAPI.onItemAdded(t, a), r.trigger("afterAddItem.ajaxCart", [t, a])
      },
      error: function (t, e) {
        "function" == typeof i ? i(t, e) : ShopifyAPI.onError(t, e), r.trigger("errorAddItem.ajaxCart", [t, e])
      },
      complete: function (t, e) {
        r.trigger("completeAddItem.ajaxCart", [this, t, e])
      }
    };
  jQuery.ajax(t)
}, ShopifyAPI.getCart = function (a) {
  $(document.body)
    .trigger("beforeGetCart.ajaxCart"), jQuery.getJSON("/cart.js", function (t, e) {
      "function" == typeof a ? a(t) : ShopifyAPI.onCartUpdate(t), $(document.body)
        .trigger("afterGetCart.ajaxCart", t)
    })
}, ShopifyAPI.changeItem = function (e, a, i) {
  var r = $(document.body);
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + a + "&line=" + e,
    dataType: "json",
    beforeSend: function () {
      r.trigger("beforeChangeItem.ajaxCart", [e, a])
    },
    success: function (t) {
      "function" == typeof i ? i(t) : ShopifyAPI.onCartUpdate(t), r.trigger("afterChangeItem.ajaxCart", [e, a, t])
    },
    error: function (t, e) {
      r.trigger("errorChangeItem.ajaxCart", [t, e]), ShopifyAPI.onError(t, e)
    },
    complete: function (t, e) {
      r.trigger("completeChangeItem.ajaxCart", [this, t, e])
    }
  })
}, theme.Drawers = function () {
  function t(t, e, a) {
    var i = {
      close: "[js-drawer-close]",
      open: "[js-drawer-open-" + e + "]",
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + e
    };
    if (this.nodes = {
        $parent: $("html")
          .add("body"),
        $page: $("#page-container")
      }, this.config = $.extend(i, a), this.position = e, this.$drawer = $("#" + t), !this.$drawer.length) return !1;
    this.drawerIsOpen = !1, this.init()
  }
  return t.prototype.init = function () {
    $(this.config.open)
      .on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this))
  }, t.prototype.open = function (t) {
    var e = !1;
    return t ? t.preventDefault() : e = !0, t && t.stopPropagation && (t.stopPropagation(), this.$activeSource = $(t.currentTarget)), this.drawerIsOpen && !e ? this.close() : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus"
    }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && !e && this.config.onDrawerOpen(), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents(), this)
  }, t.prototype.close = function () {
    this.drawerIsOpen && ($(document.activeElement)
      .trigger("blur"), this.$activeSource && this.$activeSource.attr("aria-expanded", "false"), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: "drawer_focus"
      }), this.unbindEvents())
  }, t.prototype.bindEvents = function () {
    this.nodes.$parent.on("keyup.drawer", $.proxy(function (t) {
      return 27 !== t.keyCode || (this.close(), !1)
    }, this)), this.nodes.$page.on("touchmove.drawer", function () {
      return !1
    }), this.nodes.$page.on("click.drawer", $.proxy(function () {
      return this.close(), !1
    }, this))
  }, t.prototype.unbindEvents = function () {
    this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
  }, t
}(), theme.MobileNav = function () {
  var t = {
    mobileNavDrawer: "#mobile-nav-drawer",
    mobileNavDrawerTrigger: "[js-mobile-nav-drawer-trigger]",
    mobileNavParentDrawerTrigger: "[js-mobile-nav-parent-drawer-trigger]"
  };
  return {
    init: function () {
      $(t.mobileNavDrawerTrigger)
        .on("click", function () {
          $("html")
            .toggleClass("js-mobile-nav-drawer-open"), $(t.mobileNavDrawer)
            .prepareTransition()
            .toggleClass("mobile-nav-drawer--open"), $("[js-drawer-search-form]")
            .toggleClass("search-drawer__form--with-mobile-nav")
        }), $("#mobile-nav-drawer")
        .on("click", function () {
          $("html")
            .removeClass("js-mobile-nav-drawer-open"), $(t.mobileNavDrawer)
            .prepareTransition()
            .removeClass("mobile-nav-drawer--open"), $("[js-drawer-search-form]")
            .removeClass("search-drawer__form--with-mobile-nav")
        }), $("#Mobile-Nav")
        .on("click", function (t) {
          t.stopPropagation()
        }), $(t.mobileNavParentDrawerTrigger)
        .on("click", function () {
          var t = $(this)
            .data("parent-handle");
          $(this)
            .toggleClass("active-open");
          $("[data-parent-menu='" + t + "']")
            .prepareTransition()
            .toggleClass("mobile-nav__parent-menu--open")
        })
    }
  }
}();
var ajaxCart = function ($) {
  "use strict";
  var v, n, i, y, a, o, e, s, _;

  function r(t) {
    e && (e.html(t.item_count)
      .removeClass("hidden-count"), 0 === t.item_count && e.addClass("hidden-count")), s && s.html(slate.Currency.formatMoney(t.total_price, v.moneyFormat))
  }

  function c() {
    o.removeClass("is-adding")
      .addClass("is-added"), ShopifyAPI.getCart(t)
  }

  function d(t, e) {
    t = JSON.parse(t.responseText);
    o.removeClass("is-adding is-added"), t.message && 422 === t.status && (a.after('<div class="errors qty-error">' + t.description + "</div>"), console.log(t, e))
  }

  function t(t) {
    r(t), l(t)
  }

  function l(t) {
    document.body.dispatchEvent(new Event("update-cart"));
    
    console.log(t);
    if( 0 === t.item_count){
      $("body").addClass('drawerCart-empty');
    }else{
      $("body").removeClass('drawerCart-empty');
    }
    if (_.empty(), 0 === t.item_count) return $("[js-ajaxcart-shipping-note]", y)
      .remove(), $("[js-ajaxcart-progress]", y)
      .remove(),$("body").addClass('drawerCart-empty'), _.append('<div class="ajaxcart__empty"><div class="progress-freship">Add <span>$200</span> or more to unlock free shipping<br><div class="progress-bar"></div></div><p>Your cart is currently empty.</p></div>'), void w(t);
    for (var l, e, a, i, r, n, u = [], o = $("#CartTemplate")
        .html(), o = Handlebars.compile(o), s = $("[js-ajaxcart-progress]", y), c = $("[js-ajaxcart-shipping-note]", y), d = $("[js-ajaxcart-progress-bar]", y), h = (0 < c.length && (s.remove(), c.remove()), 0 < d.length && s.remove(), $.each(t.items, function (t, e) {
             a = null != e.image ? e.image.replace(/(\.[^.]*)$/, "_medium$1")
              .replace("http:", "") : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif", 1 < e.variant_title.split("/")
              .length && (i = e.variant_title.toLowerCase()
                .replace(/\b[a-z]/g, function (t) {
                  return t.toUpperCase()
                }), r = e.variant_title.split("/")[0].trim()
                .toLowerCase()
                .replace(/\b[a-z]/g, function (t) {
                  return t.toUpperCase()
                }), n = e.variant_title.split("/")[1].trim()
                .toUpperCase());
      
            var a, i, r, n, o, s = e.variant_id,
              c = !1,
              d = ($.ajax({
                url: "/products/" + e.handle + ".js",
                dataType: "json",
                async: !1,
                success: function (t) {
                  t.compare_at_price = 0, t.variants.forEach(function (t) {
                    t.id == s && t.compare_at_price > t.price && (o = t.compare_at_price, c = !0)
                  })
                }
              }), e.discounted_price != e.original_price && (o = e.original_price, c = !0), o = null == o || o < 1 ? "" : slate.Currency.formatMoney(o, v.moneyFormat), !0);
            null !== e.properties && "true" == e.properties.giftWithPurchase && (d = !1),
              l = {
              key: e.key,
              line: t + 1,
              url: e.url,
              img: a,
              name: e.product_title,
              variation: i,
              size: n,
              color: r,
              properties: e.properties,
              itemAdd: e.quantity + 1,
              itemMinus: e.quantity - 1,
              itemQty: e.quantity,
              price: slate.Currency.formatMoney(e.price, v.moneyFormat),
              vendor: e.vendor,
              linePrice: slate.Currency.formatMoney(e.line_price, v.moneyFormat),
              originalLinePrice: slate.Currency.formatMoney(e.original_line_price, v.moneyFormat),
              discounts: e.discounts,
              discountsApplied: e.line_price !== e.original_line_price,
              isNotGiftWrap: "Gift Wrap" !== e.product_title,
              isNotGiftWithPurchase: d,
              sale: c,
              comparePrice: o
            }, u.push(l)
          }), c = {
            items: u,
            note: t.note,
            totalPrice: slate.Currency.formatMoney(t.total_price, v.moneyFormat),
            totalCartDiscount: 0 === t.total_discount ? 0 : "<span>Savings</span> " + slate.Currency.formatMoney(t.total_discount, v.moneyFormat),
            totalCartDiscountApplied: 0 !== t.total_discount
          }, _.append(o(c)), $.ajax({
            type: "get",
            url: "/pages/cart-addons",
            dataType: "html",
            async: !1,
            success: function (t) {
              var e;
              0 < $(t)
                .find("#include-ajax-addons")
                .length && (t = $(t)
                  .find("#include-ajax-addons")[0].innerHTML, e = theme.upsellNumber, $(".ajaxcart__inner")
                  .append(t), $("[js-addon-product]")
                  .slice(0, e)
                  .css("display", "flex"))
            },
            error: function (t) {
              console.log("error getting data")
            }
          }), $("[js-cart-addon-select]")
          .on("change", function (t) {
            var e = this.value;
            $(this)
              .parent(".product-single__dropdown")
              .parent(".cart-addon-product__variants")
              .next(".cart-addon-product__add")
              .attr("data-id", e)
          }), d = t, s = $(".cart-scroll-container"), "" != theme.shippingThreshold && (d = d.total_price, o = theme.shippingThreshold, c = theme.shippingTextBefore, e = theme.shippingTextAfter, a = theme.shippingMessage, i = ((o - d) / 100)
            .toFixed(0), r = d / o * 100, d < o ? (n = '<div class="ajaxcart__progress-container" js-ajaxcart-progress><div class="ajaxcart__progress"><progress class="ajaxcart__shipping-bar" max="100" value="' + r + '" js-ajaxcart-progress-bar></progress></div></div>', s.prepend(n), s.prepend("<div class='ajaxcart__shipping-note' js-ajaxcart-shipping-note>" + c + " $" + i + " " + e + "</div>")) : (n = '<div class="ajaxcart__progress-container" js-ajaxcart-progress><div class="ajaxcart__progress"><progress class="ajaxcart__shipping-bar" max="100" value="' + r + '" js-ajaxcart-progress-bar></progress></div></div>', s.prepend(n), s.prepend("<div class='ajaxcart__shipping-note' js-ajaxcart-shipping-note>" + a + "</div>"))), w(t), t), p = theme.giftWithPurchaseId, m = !1, f = 0, g = 0; g < h.items.length; g++)
     if (h.items[g].id == p) {
        m = !0, f = h.items[g].price;
        break
      } p && h.items_subtotal_price - f < theme.giftWithPurchaseMinimum && 1 == m ? $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: p,
        quantity: 0
      },
      dataType: "json",
      success: function (t) {
        ajaxCart.load();
      },
      error: function (t) {
        console.log(t)
      }
    }) : p && h.items_subtotal_price > theme.giftWithPurchaseMinimum && 0 == m && $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: p,
        quantity: 1,
        properties: {
          giftWithPurchase: !0
        }
      },
      dataType: "json",
      success: function (t) {
        ajaxCart.load()
      },
      error: function (t) {
        console.log(t)
      }
    })
  }

  function w(t) {
    document.body.dispatchEvent(new Event("update-cart-finished"));
    i.removeClass("drawer--is-loading"), i.trigger("afterCartLoad.ajaxCart", t), $("[js-ajaxcart-gift-textarea]")
      .keyup(function () {
        var t = $(this)
          .val(),
          e = t.length;
        100 == e && (t = t.substring(0, 100)), $("#ajaxcart__gift-note-count")
          .text(100 - e + " characters remaining")
      });
    for (var e = !1, a = 0; a < t.items.length; a++)
      if ("Gift Wrap - NO COLOR / OS" == t.items[a].title) {
        e = !0, $(".ajaxcart__gift-note-field")
          .slideDown(500, function () {
            $(this)
              .css("display", "block")
          }), $(".ajaxcart__gift-note-toggle")
          .css("display", "none");
        break
      } 0 == e && ($(".ajaxcart__gift-note-field")
      .slideUp(500, function () {
        $(this)
          .css("display", "none")
      }), $(".ajaxcart__gift-note-toggle")
      .css("display", "flex")), window.Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize()
  }

  function u(t) {
    r(t), setTimeout(function () {
      n = !1, ShopifyAPI.getCart(l)
    }, 150)
  }

  function h(t) {
    return t = parseFloat(t) === parseInt(t) && !isNaN(t) ? t : 1
  }
  return {
    init: function (t) {
      function r(t, e) {
        n = !0;
        var a = $('.ajaxcart__row[data-line="' + t + '"]')
          .addClass("is-loading");
        0 === e && a.parent()
          .addClass("is-removed"), setTimeout(function () {
            ShopifyAPI.changeItem(t, e, u)
          }, 250)
      }
      v = {
          ajaxCartContainer: "#ajax-cart-drawer",
          formSelector: 'form[action^="/cart/add"]',
          cartContainer: "#CartContainer",
          addToCartSelector: 'input[type="submit"]',
          cartCountSelector: null,
          cartCostSelector: null,
          moneyFormat: "${{amount}}",
          disableAjaxCart: !1,
          enableQtySelectors: !0
        }, $.extend(v, t), y = $(v.ajaxCartContainer), a = $(v.formSelector), _ = $(v.cartContainer), o = a.find(v.addToCartSelector), e = $(v.cartCountSelector), s = $(v.cartCostSelector), i = $(document.body), n = !1, v.enableQtySelectors && (t = $('input[type="number"]'))
        .length && (t.each(function () {
            var t = $(this),
              e = t.val(),
              a = t.attr("name"),
              i = t.attr("id"),
              r = e + 1,
              n = e - 1,
              o = $("#JsQty")
              .html(),
              o = Handlebars.compile(o),
              e = {
                key: t.data("id"),
                itemQty: e,
                itemAdd: r,
                itemMinus: n,
                inputName: a,
                inputId: i
              };
            t.after(o(e))
              .remove()
          }), $(".js-qty__adjust")
          .on("click", function () {
            var t = $(this),
              e = (t.data("id"), t.siblings(".js-qty__num")),
              a = h(a = parseInt(e.val()
                .replace(/\D/g, "")));
            t.hasClass("js-qty__adjust--plus") ? a += 1 : --a <= 1 && (a = 1), e.val(a)
          })), !v.disableAjaxCart && o.length && $("body")
        .on("submit", v.formSelector, function (t) {
          t.preventDefault(), o.removeClass("is-added")
            .addClass("is-adding"), $(".qty-error")
            .remove(), ShopifyAPI.addItemFromForm(t.target, c, d)
        }), i.on("click", ".ajaxcart__qty-adjust", function () {
          var t, e, a, i;
          n || (e = (t = $(this))
            .data("line"), a = t.siblings(".ajaxcart__qty-num"), i = h(i = parseInt(a.val()
              .replace(/\D/g, ""))), t.hasClass("ajaxcart__qty--plus") ? i += 1 : --i <= 0 && (i = 0), e ? r(e, i) : a.val(i))
        }), i.on("click", "[js-ajaxcart-remove]", function () {
          var t, e;
          n || (t = (e = $(this))
            .data("line"), e = e.siblings(".ajaxcart__qty-num"), t ? r(t, 0) : e.val(0))
        }), i.on("change", ".ajaxcart__qty-num", function () {
          var t, e;
          n || (t = (e = $(this))
            .data("line"), e = h(e = parseInt(e.val()
              .replace(/\D/g, ""))), t && r(t, e))
        }), i.on("submit", "form.ajaxcart", function (t) {
          n && t.preventDefault()
        }), i.on("focus", ".ajaxcart__qty-adjust", function () {
          var t = $(this);
          setTimeout(function () {
            t.select()
          }, 50)
        }), i.on("change", 'textarea[name="note"]', function () {
          var t = $(this)
            .val();
          ShopifyAPI.updateCartNote(t, function (t) {})
        })
    },
    load: function () {
      i.addClass("drawer--is-loading"), ShopifyAPI.getCart(t)
    }
  }
}(jQuery);
window.theme.reloadCart = ajaxCart.load;
window.theme = window.theme || {}, theme.CartDrawer = new theme.Drawers("ajax-cart-drawer", "right", {
    onDrawerOpen: ajaxCart.load
  }), ajaxCart.init({
    formSelector: "[data-product-form]",
    cartContainer: "#CartContainer",
    addToCartSelector: "[data-add-to-cart]",
    cartCountSelector: ".cart-count",
    moneyFormat: theme.moneyFormat
  }), jQuery(document.body)
  .on("afterCartLoad.ajaxCart", function (t, e) {
    theme.CartDrawer.open() /*,renderBeamWidget()*/
  }), theme.Accordion = function () {
    var a = "[js-accordion-group]",
      i = "[js-accordion-header]",
      r = "[js-accordion-content]";
    return {
      init: function () {
        console.log("accordions"), $("body")
          .on("click", i, function (t) {
            var e = $(this);
            "true" == e.attr("aria-expanded") ? (e.siblings()
              .slideUp(400, function () {
                $(this)
                  .attr("aria-hidden", !0)
              }), e.siblings(r)
              .find(i)
              .each(function () {
                $(this)
                  .attr("aria-expanded", !1), $(this)
                  .siblings(r)
                  .slideUp(400, function () {
                    $(this)
                      .attr("aria-hidden", !0)
                  })
              }), e.attr("aria-expanded", !1)) : (e.parent()
              .siblings()
              .find(r, a)
              .slideUp(400, function () {
                $(this)
                  .attr("aria-hidden", !0)
              }), e.parent()
              .siblings()
              .find(i, a)
              .attr("aria-expanded", !1), e.siblings(r)
              .slideDown()
              .attr("aria-hidden", !1), e.attr("aria-expanded", !0))
          })
      }
    }
  }(), theme.Klaviyo = {
    init: function () {
      KlaviyoSubscribe.attachToForms("#email_signup", {
        hide_form_on_success: !0,
        success: function () {
          $(".footer-newsletter__success")
            .show(), $("#email_signup")
            .hide()
        }
      })
    }
  }, $("body")
  .on("click", "[js-quick-add]", function (t) {
    const onFinalSale = $(this).data("final-sale");
    const isStoreCreditOnly = $(this).data("store-credit-only");
    let properties = {};
    if (onFinalSale) {
      properties = {
        "Final Sale": "Yes"
      }
    }
    if (isStoreCreditOnly) {
      properties = {
        ...properties,
        "Store Credit Only": "Yes"
      }
    }
    t.preventDefault();
    t = $(this).data("id");
    const formData = {
      items: [{
          id: t,
          quantity: 1,
          properties
        }]
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(() => ajaxCart.load())
    .catch(err => console.error(err))
  }), 
  
  $('body').on("click", "[js-gift-wrap-toggle]", function(t) {
    var isChecked = t.target.checked;
    const giftWrapId = 36934527615141;
    if (isChecked) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: "quantity=1&id=" + giftWrapId,
        error: function () {
          console.error
        },
        success: function () {
          ajaxCart.load()
        }
      })
    }
    else {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: "quantity=0&id=" + giftWrapId,
        error: function () {
          console.error
        },
        success: function () {
          ajaxCart.load()
        }
      })
    }
  }), 
  
  $("body")
  .on("click", "[js-quick-add-gift-wrap]", function (t) {
    t.preventDefault();
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: "quantity=1&id=36934527615141",
      error: function () {
        console.error
      },
      success: function () {
        ajaxCart.load()
      }
    })
  }), theme.Swatches = function () {
    function a(t) {
      t = '<span class="product__swatch-text">' + $(t.currentTarget)
        .val() + "</span>";
      $("[js-swatch-text]")
        .html(t)
    }

    function i(t) {
      var t = $(t.currentTarget),
        e = t.attr("data-variant-id"),
        a = t.closest(".swatch")
        .attr("data-option-index"),
        i = t.val();
      t.closest("form")
        .find("[data-single-option-selector]")
        .eq(a)
        .val(i)
        .trigger("change"), t.closest("form")
        .find("[data-product-select]")
        .val(e)
        .trigger("change")
    }
    return {
      init: function () {
        var t, e;
        $(".swatch")
          .length && ((t = $("[data-swatch-input]"))
            .on("click" + (e = ".swatch"), i), t.on("click" + e, a))
      }
    }
  }(), theme.SearchDrawer = function () {
    var a = {
      searchTrigger: "[js-search-trigger]",
      searchDrawer: "[js-search-drawer]"
    };
    return {
      init: function () {
        var t, e;
        t = $(a.searchTrigger), e = $(a.searchDrawer), t.on("click", function () {
          $("#mobile-nav-drawer")
            .toggleClass("mobile-nav-and-search-drawer--open"), e.prepareTransition()
            .toggleClass("search-drawer--open"), e.hasClass("search-drawer--open") ? e.find("input")
            .focus() : e.find("input")
            .focusout()
        })
      }
    }
  }(), theme.Carousel = function () {
    var e = "[js-carousel]";

    function t(t) {
      this.$container = $(t), this.initCarousel()
    }
    return t.prototype = $.extend({}, t.prototype, {
      initCarousel: function (t) {
        $(e, this.$container)
          .flickity({
            wrapAround: !0,
            pageDots: !1,
            prevNextButtons: !1,
            imagesLoaded: !0
          })
      }
    }), t
  }(), theme.QuoteCarousel = function () {
    var i = "[js-carousel]";

    function t(t) {
      this.$container = $(t), this.initCarousel()
    }
    return t.prototype = $.extend({}, t.prototype, {
      initCarousel: function (t) {
        var e = $(i, this.$container),
          a = !1;
        "" != e.data("autoplay") && (a = e.data("autoplay")), e.flickity({
          wrapAround: !0,
          pageDots: !0,
          prevNextButtons: !1,
          autoPlay: a
        })
      }
    }), t
  }(), $(document)
  .ready(function () {
    $(window)
      .scroll(function () {
        $(".template-index #MainContent .shopify-section")
          .each(function (t) {
            var e, a, i;
            $(this)
              .hasClass("fadeInUp") || (e = $(window)
                .scrollTop(), a = $(window)
                .height(), i = $(window)
                .height() / 4, $(this)
                .offset()
                .top <= e + a - i && $(this)
                .addClass("fadeInUp"))
          })
      })
  }), theme.Wishlist = function () {
    var i = {
      wishlistButton: "[js-wishlist-btn]",
      wishlistTrigger: "[js-wishlist-trigger]",
      wishlistTile: "[js-wishlist-title-container]"
    };

    function o(t, e) {
      var a; - 1 < window.location.href.indexOf("pages/wishlist") && (a = r(t, e), $(".wishlist-loader")
        .fadeOut(2e3, function () {
          0 == a ? ($(".wishlist-grid")
            .hide(), $(".wishlist-grid--empty-list")
            .show()) : ($(".wishlist-grid")
            .show(), $(".wishlist-grid--empty-list")
            .hide())
        }))
    }

    function s(t) {
      t && $(i.wishlistItemCount)
        .text(t.length)
    }
    var r = function (e, t) {
      var a = t;
      return $(i.wishlistTile)
        .each(function () {
          var t = $(this)
            .attr("data-product-handle"); - 1 === e.indexOf(t) && ($(this)
            .remove(), a--)
        }), a
    };
    return {
      init: function () {
        var r, n, e, t = localStorage.getItem("user_wishlist") || [],
          a = $(i.wishlistTile)
          .length;
        0 < t.length && (t = JSON.parse(localStorage.getItem("user_wishlist"))), $(document)
          .ready(function () {
            setTimeout(function () {
              $(".wishlist__container")
                .show()
            }, 1100)
          }), r = t, n = a, $(i.wishlistTrigger)
          .click(function (t) {
            var e, a, i;
            t.preventDefault(), t = this, e = r, a = $(t)
              .attr("data-product-handle"), $(t)
              .hasClass("wishlist--added") ? (t = e.indexOf(a), e.splice(t, 1)) : e.push(a), localStorage.setItem("user_wishlist", JSON.stringify(e)), t = this, $(t)
              .hasClass("wishlist--added") ? ($(t)
                .find(".product-card__heart .icon-heart")
                .removeClass("beating"), $(t)
                .find(".product-card__heart .icon-heart")
                .removeClass("icon-heart--active"), $(t)
                .find(".product-card__heart .icon-heart")
                .removeClass("fa-heart"), $(t)
                .find(".product-card__heart .icon-heart")
                .addClass("fa-heart-o"), $(t)
                .removeClass("wishlist--added")) : ($(t)
                .find(".product-card__heart .icon-heart")
                .addClass("beating"), $(t)
                .find(".product-card__heart .icon-heart")
                .addClass("icon-heart--active"), $(t)
                .find(".product-card__heart .icon-heart")
                .addClass("fa-heart"), $(t)
                .find(".product-card__heart .icon-heart")
                .removeClass("fa-heart-o"), $(t)
                .addClass("wishlist--added")), a = r, i = [], $.each(a, function (t, e) {
                -1 == $.inArray(e, i) && i.push(e)
              }), o(r = i, n), s(r)
          }), e = t, $(i.wishlistTrigger)
          .each(function () {
            var t = $(this)
              .attr("data-product-handle"); - 1 < e.indexOf(t) && ($(this)
              .addClass("wishlist--added"), $(this)
              .find(".product-card__heart .icon-heart")
              .addClass("icon-heart--active"), $(this)
              .find(".product-card__heart .icon-heart")
              .addClass("fa-heart"), $(this)
              .find(".product-card__heart .icon-heart")
              .removeClass("fa-heart-o"))
          }), o(t, a), s(t), $(i.wishlistButton)
          .hover(function () {
            $(this)
              .hasClass("wishlist--added") || ($(this)
                .find(".product-card__heart .icon-heart")
                .addClass("fa-heart"), $(this)
                .find(".product-card__heart .icon-heart")
                .removeClass("fa-heart-o"), $(this)
                .find(".product-card__heart .icon-heart")
                .css({
                  color: "#68634B",
                  opacity: "1"
                }))
          }, function () {
            $(this)
              .hasClass("wishlist--added") || ($(this)
                .find(".product-card__heart .icon-heart")
                .removeClass("fa-heart"), $(this)
                .find(".product-card__heart .icon-heart")
                .addClass("fa-heart-o"), $(this)
                .find(".product-card__heart .icon-heart")
                .css({
                  color: "gray",
                  opacity: "0.6"
                }))
          })
      }
    }
  }(), $("body")
  .on("click", "[js-quickadd]", function () {
    var t = $(this)
      .data("id");
    console.log(t), $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: "quantity=1&id=" + t,
      error: function () {
        console.log("error")
      },
      success: function () {
        ajaxCart.load()
      }
    })
  }), theme.Product = function () {
    var e = "[data-add-to-cart]",
      a = "[data-add-to-cart-text]",
      i = "[js-add-to-cart-container]",
      r = "[data-compare-price]",
      n = "[data-compare-text]",
      o = "[data-product-select]",
      s = "[data-product-featured-image]",
      c = "[data-product-json]",
      d = "[data-product-price]",
      l = "[data-single-option-selector]",
      u = "[js-product-images]",
      h = "[js-product-featured-images]",
      p = "[js-product-related-products]",
      m = "[js-product-popup-text]",
      f = "[js-product-icon-wrapper]",
      g = "[js-product-icon-close]",
      v = "[js-okereviews-link]";

    function t(t) {
      this.$container = $(t), $(c, this.$container)
        .html() && (this.productSingleObject = JSON.parse($(c, this.$container)
          .html()), t = {
          $container: this.$container,
          enableHistoryState: this.$container.data("enable-history-state") || !0,
          singleOptionSelector: l,
          originalSelectorId: o,
          product: this.productSingleObject
        }, this.settings = {}, this.namespace = ".product", this.variants = new slate.Variants(t), 
                    this.$featuredImage = $(s, this.$container), this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this)), 
                    this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this)), 0 < this.$featuredImage.length && (this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr("src")), slate.Image.preload(this.productSingleObject.images, this.settings.imageSize), this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this))), this.initAfterpay(), this.initFeaturedImages(this.$container), this.initRelatedProducts(this.$container), this.initProductImages(this.$container), this.openLifeCyclePopup(this.$container), this.scrollToReviews(this.$container), this.initSelectASize(this.$container), this.initAddToCartState(this.variants))
    }
    return t.prototype = $.extend({}, t.prototype, {
      initAddToCartState: function (t) {
        currentVariant = t.currentVariant
      },
      updateAddToCartState: function (t) {
        t.variant.available ? ($(i, this.$container)
          .removeClass("product__btn--hidden"), $(i, this.$container)
          .addClass("product__btn--visible"), $(".klaviyo-bis-trigger")
          .removeClass("product__btn--visible"), $(".klaviyo-bis-trigger")
          .addClass("product__btn--hidden")) : ($(i, this.$container)
          .removeClass("product__btn--visible"), $(i, this.$container)
          .addClass("product__btn--hidden"), $(".klaviyo-bis-trigger")
          .removeClass("product__btn--hidden"), $(".klaviyo-bis-trigger")
          .addClass("product__btn--visible"))
      },
      updateProductPrices: function (t) {
        var t = t.variant,
          e = $(r, this.$container),
          a = e.add(n, this.$container);
        $(d, this.$container)
          .html(slate.Currency.formatMoney(t.price, theme.moneyFormat)), t.compare_at_price > t.price ? (e.html(slate.Currency.formatMoney(t.compare_at_price, theme.moneyFormat)), a.removeClass("hide")) : (e.html(""), a.addClass("hide"))
      },
      updateProductImage: function (t) {
        t = t.variant, t = slate.Image.getSizedImageUrl(t.featured_image.src, this.settings.imageSize);
        this.$featuredImage.attr("src", t)
      },
      initAfterpay: function () {
        $(window)
          .load(function () {
            var t = $(".afterpay-paragraph")
              .find(".afterpay-logo");
            $(".afterpay-paragraph")
              .find(".afterpay-link")
              .html('<div class="afterpay-logo__container"><img class="afterpay-logo" src="https://static.afterpay.com/integration/product-page/logo-afterpay-black.png" srcset="https://static.afterpay.com/integration/product-page/logo-afterpay-black.png 1x, https://static.afterpay.com/integration/product-page/logo-afterpay-black@2x.png 2x, https://static.afterpay.com/integration/product-page/logo-afterpay-black@3x.png 3x" width="100" height="21" alt="Afterpay" style="vertical-align: middle; width: 100px; border: 0px;"><img class="afterpay-link-icon" style="width:14px;vertical-align:middle" src="https://cdn.shopify.com/s/files/1/0518/6281/files/icon-more-information.png?v=1602196321" alt="Afterpay More Info Icon" /></div>'), t.hide()
          })
      },
      initFeaturedImages: function (t) {
        t = $(h, t);
        0 < t.length && (t.show(), new Glider(document.querySelector(h), {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          draggable: !0,
          arrows: {
            prev: ".product-featured-images .slick-btn.prev",
            next: ".product-featured-images .slick-btn.next"
          },
          dragVelocity: 1,
          duration: 2,
          responsive: [{
            breakpoint: 540,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 1
            }
          }]
        }))
      },
      initRelatedProducts: function (t) {
        t = $(p, t);
        0 < t.length && (t.show(), new Glider(document.querySelector(p), {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          draggable: !0,
          arrows: {
            prev: ".product-related-products .slick-btn.prev",
            next: ".product-related-products .slick-btn.next"
          },
          dragVelocity: 1,
          duration: 2,
          responsive: [{
              breakpoint: 768,
              settings: {
                slidesToShow: 3.5,
                slidesToScroll: 1
              }
            }


            , {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4.5,
                slidesToScroll: 1
              }
            }
          ]
        }))
      },
      initProductImages: function (t) {
        t = $(u, t);
        0 < t.length && (t.show(), new Glider(document.querySelector(u), {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          draggable: !0,
          arrows: {
            prev: ".product-image-container .slick-btn.prev",
            next: ".product-image-container .slick-btn.next"
          },
          dragVelocity: 1,
          duration: 2
        }))
      },
      openLifeCyclePopup: function (t) {
        var e = $(m, t),
          a = $(f, t),
          t = $(g, t);
        a.on("click", function () {
            e.toggle()
          }), t.on("click", function () {
            e.hide()
          }), $(document)
          .mouseup(function (t) {
            e.is(t.target) || 0 !== e.has(t.target)
              .length || e.hide()
          })
      },
      scrollToReviews: function (t) {
        var e = $(v, t);
        enquire.register(theme.config.mediaQueries.smallDown, {
            match: function () {
              e.on("click", function () {
                $([document.documentElement, document.body])
                  .animate({
                    scrollTop: $("#product-okeReviews")
                      .offset()
                      .top - 112
                  }, 500)
              })
            }
          })
          .register(theme.config.mediaQueries.mediumUp, {
            match: function () {
              e.on("click", function () {
                $([document.documentElement, document.body])
                  .animate({
                    scrollTop: $("#product-okeReviews")
                      .offset()
                      .top - 130
                  }, 500)
              })
            }
          })
      },
      initSelectASize: function (t) {
        $(document)
          .on("change", $(o), function () {
            $(e, t)
              .prop("disabled", !1), $(a, t)
              .html("Add to Tote")
          })
      },
      onUnload: function () {
        this.$container.off(this.namespace)
      }
    }), t
  }(), theme.Factories = function () {
    $(".factory-modal__trigger")
      .on("click", function () {
        $($(this)
            .closest(".factory-card"))
          .find(".factory-modal__overlay")
          .addClass("active")
      }), $(".factory-modal__close")
      .on("click", function () {
        $(this)
          .closest(".factory-modal__overlay")
          .removeClass("active")
      })
  }, theme.Header = function () {
    var i = "[js-promo-bar-carousel]";
    return function (t) {
      this.$container = $(t);
      var e, t = $(i),
        a = !1;
      "" != t.data("autoplay") && (a = !0, autoplaySpeed = t.data("autoplay")), t.slick({
          arrows: !1,
          dots: !1,
          draggable: !1,
          swipe: !1,
          fade: !0,
          autoplay: a,
          autoplaySpeed: autoplaySpeed
        }), $(window)
        .scroll(function () {
          158 <= $(window)
            .scrollTop() ? $(".custom-select")
            .addClass("fixed-custom") : $(".custom-select")
            .removeClass("fixed-custom")
        }), 1 <= $(".collection-filter--mobile")
        .length && (e = $(".collection-filter--mobile")
          .offset()
          .top - 117, t = $(window)
          .scrollTop(), e <= t ? ($(".collection-filter--mobile")
            .addClass("fixed-filter"), $(".collection-products")
            .addClass("opened-filter")) : ($(".collection-filter--mobile")
            .removeClass("fixed-filter"), $(".collection-products")
            .removeClass("opened-filter")), $(window)
          .scroll(function () {
            var t = $(window)
              .scrollTop();
            e <= t ? ($(".collection-filter--mobile")
              .addClass("fixed-filter"), $(".collection-products")
              .addClass("opened-filter")) : ($(".collection-filter--mobile")
              .removeClass("fixed-filter"), $(".collection-products")
              .removeClass("opened-filter"))
          }))
    }
  }(), theme.Materials = function () {
    $(".material-modal__trigger")
      .on("click", function () {
        $($(this)
            .closest(".material-card"))
          .find(".material-modal__overlay")
          .addClass("active")
      }), $(".material-modal__close")
      .on("click", function () {
        $(this)
          .closest(".material-modal__overlay")
          .removeClass("active")
      })
  }, theme.CircularityHighlights = function () {
    var i = "[js-collection-carousel]",
      a = "[js-collection-carousel-trigger]";

    function t(t) {
      this.$container = $(t), this.initCarousel(), this.switchCarousel()
    }
    return t.prototype = $.extend({}, t.prototype, {
      initCarousel: function (t) {
        for (var e = $(i, this.$container), a = 0; a < e.length; a++) new Glider(e[a], {
          slidesToShow: 2,
          slidesToScroll: 1,
          draggable: !0,
          arrows: {
            prev: ".slick-btn_" + a + ".prev",
            next: ".slick-btn_" + a + ".next"
          },
          dragVelocity: 1,
          duration: 2,
          responsive: [{
            breakpoint: 540,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }]
        })
      },
      switchCarousel: function (t) {
        $(this.$container)
          .on("click", a, function () {
            $(this)
              .hasClass("active") || ($(a)
                .removeClass("active"), $(this)
                .addClass("active"));
            var t = $(this)
              .data("carousel"),
              e = $("[data-carousel-highlight='" + t + "']");
            $(i)
              .parent()
              .removeClass("active"), e.parent()
              .addClass("active"), Glider(document.querySelector("[data-carousel-highlight='" + t + "']"))
              .refresh()
          })
      }
    }), t
  }(), theme.CollectionsHighlight = function () {
    var i = "[js-collection-carousel]",
      a = "[js-collection-carousel-trigger]";

    function t(t) {
      this.$container = $(t), this.initCarousel(), this.switchCarousel()
    }
    return t.prototype = $.extend({}, t.prototype, {
      initCarousel: function (t) {
        for (var e = $(i, this.$container), a = 0; a < e.length; a++) new Glider(e[a], {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          draggable: !0,
          arrows: {
            prev: ".slick-btn_" + a + ".prev",
            next: ".slick-btn_" + a + ".next"
          },
          dragVelocity: 1,
          duration: 2,
          responsive: [{
            breakpoint: 540,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 1
            }
          }]
        })
      },
      switchCarousel: function (t) {
        $(this.$container)
          .on("click", a, function () {
            $(this)
              .hasClass("active") || ($(a)
                .removeClass("active"), $(this)
                .addClass("active"));
            var t = $(this)
              .data("carousel"),
              e = $("[data-carousel-highlight='" + t + "']");
            $(i)
              .parent()
              .removeClass("active"), e.parent()
              .addClass("active"), Glider(document.querySelector("[data-carousel-highlight='" + t + "']"))
              .refresh()
          })
      }
    }), t
  }(), theme.FeaturedImages = function () {
    var e = "[js-featured-images-carousel]";

    function t(t) {
      this.$container = $(t), this.initCarousel()
    }
    return t.prototype = $.extend({}, t.prototype, {
      initCarousel: function (t) {
        enquire.register(theme.config.mediaQueries.smallDown, {
            match: function () {
              var t = $(e, this.$container);
              t.hasClass("flickity-enabled") && t.flickity("destroy"), t.flickity({
                wrapAround: !1,
                pageDots: !0,
                prevNextButtons: !1,
                cellAlign: "left",
                imagesLoaded: !0
              })
            }
          })
          .register(theme.config.mediaQueries.mediumUp, {
            match: function () {
              var t = $(e, this.$container);
              t.hasClass("flickity-enabled") && t.flickity("destroy"), t.flickity({
                wrapAround: !0,
                pageDots: !0,
                prevNextButtons: !1,
                imagesLoaded: !0
              })
            }
          })
      }
    }), t
  }(), theme.ImageBlocks = function () {
    var a = "[js-image-blocks-carousel]";
    return function (t) {
      this.$container = $(t);
      var e = $(a, this.$container);
      enquire.register(theme.config.mediaQueries.smallDown, {
          match: function () {
            e.flickity({
              wrapAround: !0,
              pageDots: !0,
              prevNextButtons: !1,
              cellAlign: "center",
              imagesLoaded: !0
            })
          }
        })
        .register(theme.config.mediaQueries.mediumUp, {
          match: function () {
            e.hasClass("flickity-enabled") && e.flickity("destroy")
          }
        })
    }
  }(), theme.Slider = function () {
    function t(t) {
      this.buildCarousel(t)
    }
    return t.prototype = $.extend({}, t.prototype, {
      buildCarousel: function (t) {
        $(t)
          .slick({
            arrows: !0,
            dots: !0,
            infinte: !0,
            prevArrow: "<div class='slick-prev arrow-prev'><svg width='37.765' height='28.321' viewBox='0 0 37.765 28.321'><g transform='translate(-25 -29.998)'><path d='M46.556,56.272,48.6,58.319,62.765,44.159,48.6,30l-2.047,2.047L57.221,42.711H25v2.9H57.221Z' transform='translate(0 0)'/></g></svg></div>",
            nextArrow: "<div class='slick-next arrow-next'><svg width='37.765' height='28.321' viewBox='0 0 37.765 28.321'><g transform='translate(-25 -29.998)'><path d='M46.556,56.272,48.6,58.319,62.765,44.159,48.6,30l-2.047,2.047L57.221,42.711H25v2.9H57.221Z' transform='translate(0 0)'/></g></svg></div>"
          })
      }
    }), t
  }(), theme.MobileSlider = function () {
    var a = "[js-carousel]",
      i = "[js-nav]";

    function t(t) {
      this.$container = $(t);
      var t = $(a, this.$container),
        e = $(i, this.$container);
      this.buildCarousel(t), this.buildNav(e)
    }
    return t.prototype = $.extend({}, t.prototype, {
      buildCarousel: function (t) {
        t.slick({
          arrows: !0,
          dots: !1,
          infinte: !0,
          asNavFor: ".slider-for",
          fade: !0,
          adaptiveHeight: !0,
          prevArrow: "<div class='slick-prev arrow-prev'><svg width='37.765' height='28.321' viewBox='0 0 37.765 28.321'><g transform='translate(-25 -29.998)'><path d='M46.556,56.272,48.6,58.319,62.765,44.159,48.6,30l-2.047,2.047L57.221,42.711H25v2.9H57.221Z' transform='translate(0 0)'/></g></svg></div>",
          nextArrow: "<div class='slick-next arrow-next'><svg width='37.765' height='28.321' viewBox='0 0 37.765 28.321'><g transform='translate(-25 -29.998)'><path d='M46.556,56.272,48.6,58.319,62.765,44.159,48.6,30l-2.047,2.047L57.221,42.711H25v2.9H57.221Z' transform='translate(0 0)'/></g></svg></div>"
        })
      },
      buildNav: function (t) {
        t.slick({
          arrows: !1,
          dots: !0,
          infinte: !0,
          fade: !0,
          adaptiveHeight: !0,
          asNavFor: ".slider-for"
        })
      }
    }), t
  }(), theme.customerAddresses = void($("#address_form_new")
    .length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
        hideElement: "AddressProvinceContainerNew"
      }), $(".address-country-option")
      .each(function () {
        var t = $(this)
          .data("form-id");
        new Shopify.CountryProvinceSelector("AddressCountry_" + t, "AddressProvince_" + t, {
          hideElement: "AddressProvinceContainer_" + t
        })
      }), enquire.register(theme.config.mediaQueries.smallDown, {
        match: function () {
          $("[js-address-edit]")
            .on("click", function () {
              var t = $(this)
                .data("form-id");
              $("#address_form_" + t)
                .toggle(), $(".account-address__edit--mobile")
                .toggle(), $(".account-address__default-address")
                .toggle()
            })
        }
      }), enquire.register(theme.config.mediaQueries.mediumUp, {
        match: function () {
          $("[js-address-edit]")
            .on("click", function () {
              var t = $(this)
                .data("form-id");
              $("#address_form_" + t)
                .toggle(), $(".account-address__edit--desktop")
                .toggle(), $("#account-address-new")
                .toggle()
            })
        }
      }), $("[js-address-delete]")
      .on("click", function () {
        var t = $(this),
          e = t.data("form-id"),
          t = t.data("confirm-message");
        confirm(t || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + e, {
          parameters: {
            _method: "delete"
          }
        })
      }))), theme.customerLogin = function () {
    var t = "[js-show-recover]",
      e = "[js-hide-recover]";

    function a(t) {
      t.preventDefault(), i()
    }

    function i() {
      $(".login__recover")
        .toggle(), $(".login__login")
        .toggle()
    }
    $(t)
      .length && ("#recover" === window.location.hash && i(), $(".reset-password-success")
        .length && $("#ResetSuccess")
        .removeClass("hide"), $(t)
        .on("click", a), $(e)
        .on("click", a))
  }(), theme.AccountDashboard = function (t) {
    this.$container = $(t), enquire.register(theme.config.mediaQueries.smallDown, {
      match: function () {
        $("#account__overview", this.$container)
          .attr("aria-hidden", !0), $('[aria-controls="account__overview"]', this.$container)
          .attr("aria-expanded", !1)
      },
      unmatch: function () {
        $(".account__accordion-header", this.$container)
          .attr("aria-expanded", !0), $("#account__orders, #account__overview", this.$container)
          .removeAttr("aria-hidden")
          .removeAttr("style")
      }
    })
  }, theme.AccountAddress = function (t) {
    this.$container = $(t), enquire.register(theme.config.mediaQueries.smallDown, {
      match: function () {
        $("#account-address-new", this.$container)
          .attr("aria-hidden", !0), $('[aria-controls="account-address-new"]', this.$container)
          .attr("aria-expanded", !1)
      },
      unmatch: function () {
        $(".account__accordion-header", this.$container)
          .attr("aria-expanded", !0), $("#account-address-new, #account-address-list", this.$container)
          .removeAttr("aria-hidden")
          .removeAttr("style")
      }
    })
  }, theme.AccountCreate = function () {
    $("#create_customer")
      .submit(function (t) {
        $('input[name="customer[password]"]')
          .val() != $('input[name="customer[password_confirmation]"]')
          .val() && (t.preventDefault(), $("[js-pw-error]")
            .show())
      })
  }, theme.Collection = function () {
    var a = "[js-grid-change-trigger]",
      i = "[js-collection-products]",
      r = "[js-collection-filter-selector-trigger]";

    function t(t) {
      this.$container = $(t), this.gridChange(this.$container), this.selectFilter(this.$container), this.onLoadHide(this.$container), this.autoAdjustHeight(this.$container)
    }
    return t.prototype = $.extend({}, t.prototype, {
      selectFilter: function (t) {
        $(document)
          .mouseup(function (t) {
            var e = $(r),
              a = $(".collection-filter__container--trigger");
            e.is(t.target) ? (e = $(t.target)
                .data("filter"), $(t.target)
                .hasClass("active") ? ($(t.target)
                  .removeClass("active"), $(".collection-filter__container--trigger." + e)
                  .toggle()) : ($(t.target)
                  .addClass("active"), $(".collection-filter__container--trigger." + e)
                  .toggle(), $(".active-filter")
                  .html(e)), $(r)
                .not(t.target)
                .removeClass("active"), $(".collection-filter__container--trigger")
                .not(".collection-filter__container--trigger." + e)
                .hide()) : a.is(t.target) || 0 !== a.has(t.target)
              .length || ($(r)
                .removeClass("active"), a.hide()), $(r)
              .hasClass("active") ? $("html")
              .addClass("collection-filter-overlay") : $("html")
              .removeClass("collection-filter-overlay"), "sort-desktop" == $(".collection-filter__toggle-link.active")
              .data("filter") && $("html")
              .removeClass("collection-filter-overlay")
          })
      },
      gridChange: function (e) {
        e.on("click", a, function () {
          var t = $(this)
            .data("grid");
          switch ($(a, e)
            .removeClass("active"), $(this)
            .addClass("active"), t) {
            case "2x":
              $(".product-editorial__image")
                .each(function () {
                  1 != $(this)
                    .css("grid-column") && $(this)
                    .css("grid-column", 2)
                }), enquire.register(theme.config.mediaQueries.smallDown, {
                  match: function () {
                    $(i, e)
                      .css("grid-template-columns", "repeat(2, 1fr)")
                  }
                })
                .register(theme.config.mediaQueries.mediumUp, {
                  match: function () {
                    $(i, e)
                      .css("grid-template-columns", "repeat(2, 1fr)")
                  }
                });
              break;
            case "3x":
              $(".product-editorial__image")
                .each(function () {
                  -1 != $(this)
                    .css("grid-column-end") && $(this)
                    .css("grid-column", "initial")
                }), enquire.register(theme.config.mediaQueries.smallDown, {
                  match: function () {
                    $(i, e)
                      .css("grid-template-columns", "repeat(2, 1fr)")
                  }
                })
                .register(theme.config.mediaQueries.mediumUp, {
                  match: function () {
                    $(i, e)
                      .css("grid-template-columns", "repeat(3, 1fr)")
                  }
                })
          }
          t = $(".product-card")
            .height();
          $(".product-editorial__image:last-child")
            .css("height", t), $(window)
            .resize(function () {
              var t = $(".product-card")
                .height();
              $(".product-editorial__image:last-child")
                .css("height", t)
            }), $(window)
            .trigger("resize")
        })
      },
      onLoadHide: function (t) {
        $(i)
          .each(function (t) {
            0 == $(this)
              .children()
              .length && $(this)
              .parent()
              .hide()
          })
      },
      autoAdjustHeight: function (t) {
        var e = $(".product-card")
          .height();
        $(".product-editorial__image:last-child")
          .css("height", e), $(window)
          .resize(function () {
            var t = $(".product-card")
              .height();
            $(".product-editorial__image:last-child")
              .css("height", t)
          }), $(window)
          .trigger("resize")
      },
      onUnload: function () {
        this.$container.off(this.namespace)
      }
    }), t
  }(), theme.Circularity = function () {
    var e = "[js-steps-carousel]";
    return function (t) {
      this.$container = $(t), enquire.register(theme.config.mediaQueries.smallDown, {
        match: function () {
          $(e)
            .flickity({
              prevNextButtons: !1
            })
        },
        unmatch: function () {
          $(e)
            .flickity("destroy")
        }
      })
    }
  }(), theme.Blog = function () {
    var a = "[js-blog]",
      i = "[js-article]",
      r = "[js-pagination]",
      n = "[js-dropdown-trigger]",
      o = "[js-dropdown-menu]";
    return function (t) {
      this.$container = $(t);
      var e = (t = $(a, this.$container)
          .masonry({
            itemSelector: i,
            columnWidth: i,
            percentPosition: !0
          }))
        .data("masonry");
      t.infiniteScroll({
        path: r,
        append: i,
        history: !1,
        scrollThreshold: 100,
        outlayer: e,
        hideNav: ".pagination"
      }), enquire.register(theme.config.mediaQueries.smallDown, {
        match: function () {
          $(n)
            .on("click", function () {
              $(o)
                .toggleClass("active")
            })
        }
      })
    }
  }(), theme.Bundle = function () {
    var f = "[js-bundle-product]",
      g = "[js-product-image-link]",
      v = "[js-product-image]",
      p = "[js-product-select]",
      y = "[js-selected-color]",
      _ = "[js-color-container]",
      w = "[js-saving]",
      C = "[js-original-price]",
      b = "[js-discount-price]",
      j = "[js-color-swatches]",
      x = "[js-color-select]",
      S = "[js-size-container]",
      k = "[js-size-accordion-header]",
      T = "[js-size-accordion-content]",
      e = "[js-size-select]",
      A = "[js-add-to-bundle]",
      a = "[js-set-product]",
      i = "[js-remove]",
      r = "[js-add-to-cart]",
      n = "[js-bundle-set]",
      o = "[js-savings]",
      s = "[js-subtotal]";

    function t(t) {
      this.$container = $(t), this.$productSelects = this.$container.find(p), this.$colorSelects = this.$container.find(x), this.$sizeSelects = this.$container.find(e), this.$addToBundles = this.$container.find(A), this.$setProducts = this.$container.find(a), this.$removeFromBundle = this.$container.find(i), this.$addToCart = this.$container.find(r), this.$bundleSet = this.$container.find(n), this.$bundleSavings = this.$container.find(o), this.$bundleSubtotal = this.$container.find(s), this.$productSelects.on("change", this.updateColorOption.bind(this)), this.$colorSelects.on("change", this.updateSizes.bind(this)), this.$sizeSelects.on("click", this.updateAddToBundle.bind(this)), $("body")
        .on("click", e, this.updateAddToBundle.bind(this)), this.$addToBundles.on("click", this.addToBundle.bind(this)), this.$removeFromBundle.on("click", this.removeFromBundle.bind(this)), this.$addToCart.on("click", this.addToCart.bind(this)), this.configAccordions()
    }
    return t.prototype = $.extend({}, t.prototype, {
      updateColorOption: function (t) {
        var t = $(t.currentTarget),
          e = t.closest(f),
          a = e.find(g),
          i = e.find(y),
          r = e.find(v),
          n = e.find(w),
          o = e.find(C),
          s = e.find(b),
          c = e.find(A),
          t = t.val(),
          d = e.find(_),
          l = e.find(j + '[data-product="' + t + '"]'),
          u = $(l.find(x)[0])
          .val()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, ""),
          h = e.find(x),
          p = e.find(S),
          m = e.find(k),
          e = e.find(T);
        this.colorChange(c, t + "-" + u, a, r, n, o, s), i.html(""), d.show(), l.siblings()
          .hide(), l.show(), h.removeAttr("checked"), p.show(), m.attr("disabled", "disabled")
          .attr("aria-expanded", "false"), e.attr("aria-hidden", "true")
          .hide(), e.empty()
      },
      updateSizes: function (t) {
        var t = $(t.currentTarget),
          e = t.closest(f),
          a = e.find(g),
          i = e.find(y),
          r = e.find(v),
          n = e.find(w),
          o = e.find(C),
          s = e.find(b),
          c = e.find(A),
          d = e.find(p)
          .val(),
          l = t.val(),
          d = d + "-" + t.val()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, ""),
          u = e.find(k),
          h = e.find(T);
        this.colorChange(c, d, a, r, n, o, s), i.html(l), u.attr("aria-expanded", "false"), h.attr("aria-hidden", "true")
          .hide(), h.empty(), $.ajax({
            type: "get",
            url: "/products/" + d + ".js",
            dataType: "json",
            async: !1
          })
          .done(function (a) {
            a.variants.forEach(function (t) {
              a.price;
              var e = 100 * Math.round(.2 * a.price / 100),
                e = (a.price, 'data-id="' + t.id + '" data-name="' + a.title + '" data-image="' + a.images[1] + '" data-price="' + (a.price - e) + '" data-color="' + t.option1 + '" data-size="' + t.option2 + '" data-savings="' + e + '" ');
              t.available ? h.append('<button class="bundle-product__size" ' + e + " js-size-select>" + t.option2 + "</button>") : h.append('<button class="bundle-product__size" ' + e + " disabled js-size-select>" + t.option2 + "</button>")
            }), u.removeAttr("disabled")
          })
      },
      updateAddToBundle: function (t) {
        var t = $(t.currentTarget),
          e = t.closest(f)
          .find(A);
        e.attr("data-id", t.data("id")), e.attr("data-name", t.data("name")), e.attr("data-image", t.data("image")), e.attr("data-price", t.data("price")), e.attr("data-color", t.data("color")), e.attr("data-size", t.data("size")), e.attr("data-savings", t.data("savings")), e.removeAttr("disabled"), t.addClass("active")
          .siblings()
          .removeClass("active"), e.html("Add To Set"), e.show()
      },
      addToBundle: function (t) {
        var t = $(t.currentTarget),
          e = t.data("item"),
          e = $(this.$setProducts[e]),
          a = '<img class="bundle-set-product__image" src="' + t.attr("data-image") + '" alt="' + t.attr("data-name") + '" />';
        e.attr("data-id", t.attr("data-id")), e.attr("data-savings", t.attr("data-savings")), e.attr("data-price", t.attr("data-price")), e.find("[js-image]")
          .html(a), e.find("[js-name]")
          .html(t.attr("data-name")), e.find("[js-price]")
          .html(slate.Currency.formatMoney(t.attr("data-price"), "${{amount_no_decimals}}")), e.find("[js-color]")
          .html("Color: " + t.attr("data-color")), e.find("[js-size]")
          .html("Size: " + t.attr("data-size")), e.find(i)
          .show()
          .removeAttr("disabled"), t.html("Added!"), this.checkAdd()
      },
      colorChange: function (t, e, a, i, r, n, o) {
        this.clearAdd(t), this.changeOptions(e, a, i, r, n, o)
      },
      clearAdd: function (t) {
        t.removeAttr("data-id")
          .removeAttr("data-name")
          .removeAttr("data-image")
          .removeAttr("data-price")
          .removeAttr("data-color")
          .removeAttr("data-size")
          .removeAttr("data-savings"), t.hide(), t.html("Add To Set"), t.attr("disabled", "disabled")
      },
      changeOptions: function (t, r, n, o, s, c) {
        fetch("/products/" + t + ".js")
          .then(t => {
            t.json()
              .then(t => {
                var e = t.price,
                  a = 100 * Math.round(.2 * t.price / 100),
                  i = t.price - a;
                r.attr("href", t.url), n.attr("src", t.images[1]), o.html(slate.Currency.formatMoney(a, "${{amount_no_decimals}}")), s.html(slate.Currency.formatMoney(e, "${{amount_no_decimals}}")), c.html(slate.Currency.formatMoney(i, "${{amount_no_decimals}}"))
              })
          })
          .catch(t => {
            console.error("Error:", t)
          })
      },
      removeFromBundle: function (t) {
        var t = $(t.currentTarget),
          e = t.closest(a);
        e.removeAttr("data-id"), e.attr("data-savings", 0), e.attr("data-price", 0), e.find("[js-image]")
          .empty(), e.find("[js-name]")
          .html(t.data("placeholder")), e.find("[js-price]")
          .empty(), e.find("[js-color]")
          .empty(), e.find("[js-size]")
          .empty(), t.attr("disabled", "disabled"), t.hide(), this.checkAdd()
      },
      checkAdd: function (t) {
        this.$bundleSet.show();
        var e = !0,
          a = 0,
          i = 0;
        $(this.$setProducts)
          .each(function () {
            a += parseInt($(this)
                .attr("data-savings")), i += parseInt($(this)
                .attr("data-price")), void 0 === $(this)
              .attr("data-id") && (e = !1)
          }), e ? this.$addToCart.removeAttr("disabled")
          .show() : this.$addToCart.attr("disabled", "disabled")
          .hide(), this.$bundleSubtotal.html(slate.Currency.formatMoney(i, "${{amount_no_decimals}}")), this.$bundleSavings.html(slate.Currency.formatMoney(a, "${{amount_no_decimals}}"))
      },
      addToCart: function (t) {
        var e = {},
          a = [];
        $(this.$setProducts)
          .each(function () {
            var t = {
              id: $(this)
                .attr("data-id"),
              quantity: 1,
              properties: {
                _bundle: "true"
              }
            };
            a.push(t)
          }), e.items = a, fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
          })
          .then(t => {
            ajaxCart.load()
          })
          .catch(t => {
            console.error("Error:", t)
          })
      },
      configAccordions: function () {
        this.$container.find("[js-accordion-header]"), this.$container.find("[js-accordion-content]");
        var t = this.$container.find("[js-product-accordion-header]"),
          e = this.$container.find("[js-product-accordion-content]");
        enquire.register(theme.config.mediaQueries.mediumUp, {
          match: function () {
            t.attr("disabled", "disabled"), t.attr("aria-expanded", "true"), e.removeAttr("style"), e.attr("aria-hidden", "false")
          },
          unmatch: function () {
            t.removeAttr("disabled"), t.attr("aria-expanded", "false"), e.attr("style", "display: none;"), e.attr("aria-hidden", "true")
          }
        })
      }
    }), t
  }(), $(document)
  .ready(function () {
    var t = new slate.Sections;
    t.register("product", theme.Product), t.register("account-dashboard", theme.AccountDashboard), t.register("account-address", theme.AccountAddress), t.register("account-create", theme.AccountCreate), t.register("collection", theme.Collection), t.register("factories", theme.Factories), t.register("header", theme.Header), t.register("materials", theme.Materials), t.register("carousel", theme.Carousel), t.register("collections-highlight", theme.CollectionsHighlight), t.register("circularity-highlight", theme.CircularityHighlights), t.register("quote-carousel", theme.QuoteCarousel), t.register("featured-images-carousel", theme.FeaturedImages), t.register("image-blocks-carousel", theme.ImageBlocks), t.register("circularity", theme.Circularity), t.register("blog", theme.Blog), t.register("slider", theme.Slider), t.register("mobile-slider", theme.MobileSlider), t.register("bundle", theme.Bundle), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link")
      .on("click", function (t) {
        slate.a11y.pageLinkFocus($(t.currentTarget.hash))
      }), slate.rte.wrapTable({
        $tables: $(".rte table"),
        tableWrapperClass: "rte__table-wrapper"
      });
    slate.rte.wrapIframe({
      $iframes: $('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"]'),
      iframeWrapperClass: "rte__video-wrapper"
    }), slate.cart.cookiesEnabled() && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")), Handlebars.registerHelper("ifEquals", function (t, e, a) {
      return t == e ? a.fn(this) : a.inverse(this)
    }), Handlebars.registerHelper("ifContains", function (t, e, a) {
      return t.includes(e) ? a.fn(this) : a.inverse(this)
    }), Handlebars.registerHelper("handleize", function (t, e) {
      return t.toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "")
    }), Handlebars.registerHelper("split", function (t, e, a, i) {
      return t.split(e)[a]
    }), theme.MobileNav.init(), theme.Accordion.init(), theme.Swatches.init(), theme.SearchDrawer.init(), theme.Klaviyo.init(), theme.Wishlist.init()
  }), ! function () {
    var t = document.querySelectorAll('#create_customer, form[action$="/account"][method="post"]')[0];
    t && (($redirect = document.createElement("input"))
      .setAttribute("name", "return_to"), $redirect.setAttribute("type", "hidden"), $redirect.value = "/account", t.appendChild($redirect))
  }();